// @ts-ignore
export const isFreschatWidgetReady = () => Boolean(window.fcWidget);
// @ts-ignore
// Must be called only if isFreschatWidgetReady() return true
export const getFreshchatWidget = () => window.fcWidget;
